import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import * as React from 'react';
import {styled} from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import PollTextField from '../forms/PollTextField';
import IconButton from '@mui/material/IconButton';
import CardHeader from '@mui/material/CardHeader';
import CloseIcon from '@mui/icons-material/Close';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function ImageBasedPoll({options}) {

  const renderUploadButton = () => {
    return <Button component="label" variant="outlines" startIcon={<CloudUploadIcon/>}>
      Upload file
      <VisuallyHiddenInput type="file"/>
    </Button>
  }
  return <FormControl sx={{m: 1}} variant="outlined">
    <Grid container spacing={2}>
      {options.map((option, index) => {
        return <Grid item xs={12}>
          <Card variant="outlined" sx={{minWidth: 140}}>
            <CardHeader action={
              <IconButton aria-label="settings">
                <CloseIcon/>
              </IconButton>
            }
            />
            <CardContent>
              {renderUploadButton()}
            </CardContent>
            <CardActions>
              <PollTextField label={'caption'} size="small"/>
            </CardActions>
          </Card>
        </Grid>
      })}
    </Grid>

  </FormControl>

}
